import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import './Home.css';
import HomeService from '../services/HomeService';
import { useNavigate } from 'react-router-dom';

export default function Home() {
  const navigate = useNavigate();
  const [pendingCount, setPendingCount] = useState(0);
  const [approvedCount, setapprovedCount] = useState(0);
  const [holdCount, setholdCount] = useState(0);
  const [closedCount, setclosedCount] = useState(0);
  const [rejectCount, setrejectCount] = useState(0);
  const [requestCount, setrequestCount] = useState(0);
  useEffect(() => {
    const fetchDashboardCount = async () => {
      const pendingResponse = await HomeService.getDashboardData('Pending');
      const approvedResponse = await HomeService.getDashboardData('Approved');
      const rejectResponse = await HomeService.getDashboardData('Reject');
      const closedResponse = await HomeService.getDashboardData('Closed');
      const requestResponse = await HomeService.getDashboardData('Request');
      const holdResponse = await HomeService.getDashboardData('Hold');

      debugger
      if (pendingResponse.data.statusCode == "200") {
        setPendingCount(pendingResponse.data.result.recordCount);
      }
      if (requestResponse.data.statusCode == "200") {
        setrequestCount(requestResponse.data.result.recordCount);
      }
      if (approvedResponse.data.statusCode == "200") {
        setapprovedCount(approvedResponse.data.result.recordCount);
      }
      if (rejectResponse.data.statusCode == "200") {
        setrejectCount(rejectResponse.data.result.recordCount);
      }
      if (closedResponse.data.statusCode == "200") {
        setclosedCount(closedResponse.data.result.recordCount);
      }
      if (holdResponse.data.statusCode == "200") {
        setholdCount(holdResponse.data.result.recordCount);
      }

    };
    fetchDashboardCount();
  }, []);
  const handleNavigate = (title, type) => {
    sessionStorage.setItem('reportTitle', title);
    sessionStorage.setItem('actionType', type);
    navigate('/dashboard-report');
  };

  return (
    <Container className="my-5">
      <h2 className="text-center mb-4">Welcome to the Genus Approval Platform!</h2>
      <p className="text-center mb-5"></p>

      <Row className="g-4">
        {/* Pending Approval */}
        <Col xs={12} sm={6} lg={3}>

          <Card
            onClick={pendingCount ? () => handleNavigate('Pending Approval', 'Pending') : null}
            className="dashboard-card shadow h-100"
            style={{
              cursor: pendingCount ? 'pointer' : 'not-allowed',
              opacity: pendingCount ? 1 : 0.6,
              pointerEvents: pendingCount ? 'auto' : 'none',
            }}
          >
            <Card.Body className="d-flex align-items-center">
              <i className="fas fa-hourglass-half dashboard-icon text-warning me-3"></i>
              <div>
                <Card.Title>Pending Approval</Card.Title>
                <Card.Text>{pendingCount} request.</Card.Text>
              </div>
            </Card.Body>
          </Card>

        </Col>
        {/* Approved */}
        <Col xs={12} sm={6} lg={3}>
          <Card
            onClick={approvedCount > 0 ? () => handleNavigate('Approved Approval', 'Approved') : null}
            className="dashboard-card shadow h-100"
            style={{
              cursor: approvedCount > 0 ? 'pointer' : 'not-allowed',
              opacity: approvedCount > 0 ? 1 : 0.6,
              pointerEvents: approvedCount > 0 ? 'auto' : 'none',
            }}
          >
            <Card.Body className="d-flex align-items-center">
              <i className="fas fa-check-circle dashboard-icon text-success me-3"></i>
              <div>
                <Card.Title>Approved</Card.Title>
                <Card.Text>{approvedCount} request.</Card.Text>
              </div>
            </Card.Body>
          </Card>
        </Col>
        {/* On Hold */}
        <Col xs={12} sm={6} lg={3}>
          <Card
            onClick={holdCount ? () => handleNavigate('Hold', 'Hold') : null}
            className="dashboard-card shadow h-100"
            style={{
              cursor: holdCount ? 'pointer' : 'not-allowed',
              opacity: holdCount ? 1 : 0.6,
              pointerEvents: holdCount ? 'auto' : 'none',
            }}
          >
            <Card.Body className="d-flex align-items-center">
              <i className="fas fa-hand-paper dashboard-icon text-secondary me-3"></i> {/* Font Awesome undo icon */}
              <div>
                <Card.Title>Hold</Card.Title>
                <Card.Text>{holdCount} request.</Card.Text>
              </div>
            </Card.Body>
          </Card>
        </Col>
        {/* On Closed */}
        <Col xs={12} sm={6} lg={3}>
          <Card
            onClick={closedCount ? () => handleNavigate('On Closed Approval', 'Closed') : null}
            className="dashboard-card shadow h-100"
            style={{
              cursor: closedCount ? 'pointer' : 'not-allowed',
              opacity: closedCount ? 1 : 0.6,
              pointerEvents: closedCount ? 'auto' : 'none',
            }}
          >
            <Card.Body className="d-flex align-items-center">
              <i className="fas fa-pause-circle dashboard-icon text-primary me-3"></i>
              <div>
                <Card.Title>Closed</Card.Title>
                <Card.Text>{closedCount} requests.</Card.Text>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* Rejected */}
        <Col xs={12} sm={6} lg={3}>
        <Card
    onClick={rejectCount ? () => handleNavigate('Rejected Approval', 'Reject') : null}
    className="dashboard-card shadow h-100"
    style={{
      cursor: rejectCount ? 'pointer' : 'not-allowed',
      opacity: rejectCount ? 1 : 0.6,
      pointerEvents: rejectCount ? 'auto' : 'none',
    }}
  >
            <Card.Body className="d-flex align-items-center">
              <i className="fas fa-times-circle dashboard-icon text-danger me-3"></i>
              <div>
                <Card.Title>Revert/Reject</Card.Title>
                <Card.Text>{rejectCount} request.</Card.Text>
              </div>
            </Card.Body>
          </Card>
        </Col>
        {/* Request Approval */}
        <Col xs={12} sm={6} lg={3}>
          <Card
            onClick={requestCount ? () => handleNavigate('Requested', 'Request') : null}
            className="dashboard-card shadow h-100"
            style={{
              cursor: requestCount ? 'pointer' : 'not-allowed',
              opacity: requestCount ? 1 : 0.6,
              pointerEvents: requestCount ? 'auto' : 'none',
            }}
          >
            <Card.Body className="d-flex align-items-center">
              <i className="fas fa-file-alt dashboard-icon text-info me-3"></i> {/* Changed icon */}
              <div>
                <Card.Title>Request</Card.Title>
                <Card.Text>{requestCount} request.</Card.Text>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
